var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "interface row mb-4" },
    [
      _c(
        "div",
        { staticClass: "col-12 text-right" },
        [
          _c("input-button", {
            attrs: {
              pointable: "",
              hollow: "",
              smaller: "",
              slimmer: "",
              centered: "",
              btnStyle: "nok-style",
              inputPlaceholder: "x"
            },
            on: {
              click: function($event) {
                return _vm.$emit("close", {})
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.allEmpty && _vm.hasWP && _vm.hasSQ
        ? [
            !_vm.migrating
              ? [
                  _c("h5", { staticClass: "col-12" }, [
                    _vm._v("\n        Migracija Sqwiz -- Wordpress\n      ")
                  ]),
                  _vm._v(" "),
                  _vm.user.email
                    ? _c("p", { staticClass: "col-12" }, [
                        _vm._v("\n        Uporabnik "),
                        _c("b", [_vm._v(_vm._s(_vm.user.email))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    _vm._l(_vm.sqwizPages, function(c) {
                      return _c("row", {
                        key: c.id,
                        attrs: {
                          "sqwiz-page": c,
                          "wordpress-users": _vm.wordpressUsers,
                          "user-id": _vm.userId
                        },
                        on: {
                          fieldUpdate: _vm.updateFields,
                          update: _vm.updateRowState
                        }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 text-center" },
                    [
                      _c("input-button", {
                        attrs: {
                          pointable: "",
                          hollow: "",
                          smaller: "",
                          centered: "",
                          btnStyle: "ok-style",
                          inputPlaceholder: "Prenesi",
                          dissabled: !_vm.canMigrate
                        },
                        on: { click: _vm.migrate }
                      })
                    ],
                    1
                  )
                ]
              : _c(
                  "div",
                  { staticClass: "loading text-center col-12 m-3" },
                  [
                    _c("q-icon", {
                      attrs: {
                        allowSelfUpdate: false,
                        spin: "",
                        width: "110px",
                        name: "spinner"
                      }
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("h5", { staticClass: "mt-2" }, [
                      _vm._v("\n        Prenašam objave\n      ")
                    ])
                  ],
                  1
                )
          ]
        : !_vm.hasWP
          ? [
              _c("h5", { staticClass: "col-12" }, [
                _vm._v("\n      Migracija ni mogoča\n    ")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "col-12" }, [
                _vm._v(
                  "\n      Uporabnik nima veljavne Wordpress povezave\n    "
                )
              ])
            ]
          : !_vm.hasSQ
            ? [
                _c("h5", { staticClass: "col-12" }, [
                  _vm._v("\n      Migracija ni mogoča\n    ")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "col-12" }, [
                  _vm._v("\n      Uporabnik nima veljavne Sqwiz povezave\n    ")
                ])
              ]
            : [
                _c("h5", { staticClass: "col-12" }, [
                  _vm._v("\n      Migracija ni potrebna\n    ")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "col-12" }, [
                  _vm._v(
                    "\n      Vse objave iz Sqwiz-a so prenešene na Wordpress.\n    "
                  )
                ])
              ],
      _vm._v(" "),
      _vm.error
        ? [_c("p", { staticClass: "error mt-3" }, [_vm._v(_vm._s(_vm.error))])]
        : _vm._e(),
      _vm._v(" "),
      _vm.warning
        ? [
            _c("p", { staticClass: "warning mt-3" }, [
              _vm._v("\n      " + _vm._s(_vm.warning) + "\n    ")
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e17787f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e17787f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/display/migration/sqwiz/Interface.vue
// module id = null
// module chunks = 